/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Open_MenuInputs */

const en_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open menu`)
};

const es_nav_open_menu = /** @type {(inputs: Nav_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir menú`)
};

/**
* | output |
* | --- |
* | "Open menu" |
*
* @param {Nav_Open_MenuInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_open_menu = /** @type {((inputs?: Nav_Open_MenuInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Open_MenuInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_open_menu(inputs)
	return en_nav_open_menu(inputs)
});